import React, { useState, useRef, useEffect } from "react";

import img1 from "../../Assets/Images/CatalogImages/SAKHI MENU_page-0001.webp";
import img2 from "../../Assets/Images/CatalogImages/SAKHI MENU_page-0002.webp";
import img3 from "../../Assets/Images/CatalogImages/SAKHI MENU_page-0003.webp";
import img4 from "../../Assets/Images/CatalogImages/SAKHI MENU_page-0004.webp";
import img5 from "../../Assets/Images/CatalogImages/SAKHI MENU_page-0005.webp";
import img6 from "../../Assets/Images/CatalogImages/SAKHI MENU_page-0006.webp";
import img7 from "../../Assets/Images/CatalogImages/SAKHI MENU_page-0007.webp";
import img8 from "../../Assets/Images/CatalogImages/SAKHI MENU_page-0008.webp";
import img9 from "../../Assets/Images/CatalogImages/SAKHI MENU_page-0009.webp";
import img10 from "../../Assets/Images/CatalogImages/SAKHI MENU_page-0010.webp";
import img11 from "../../Assets/Images/CatalogImages/SAKHI MENU_page-0011.webp";
import img12 from "../../Assets/Images/CatalogImages/SAKHI MENU_page-0012.webp";
import img13 from "../../Assets/Images/CatalogImages/SAKHI MENU_page-0013.webp";
import img14 from "../../Assets/Images/CatalogImages/SAKHI MENU_page-0014.webp";
import sakhi_menu_pdf from "../../Assets/Pdf/SAKHI MENU.pdf";

const pages = [
  img1, img2, img3, img4, img5, img6,
  img7, img8, img9, img10, img11, img12, img13, img14
];

const CatalogBook = () => {
  const [page, setPage] = useState(0);
  const [animating, setAnimating] = useState(false);
  const touchStartX = useRef(null);

  /* ---------- PRELOAD IMAGES  ---------- */
  useEffect(() => {
    pages.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, []);

  /* ---------- PAGE CONTROLS ---------- */
  const flipNext = () => {
    if (page >= pages.length - 1 || animating) return;
    setAnimating(true);
    setTimeout(() => {
      setPage((p) => p + 1);
      setAnimating(false);
    }, 300);
  };

  const flipPrev = () => {
    if (page <= 0 || animating) return;
    setAnimating(true);
    setTimeout(() => {
      setPage((p) => p - 1);
      setAnimating(false);
    }, 300);
  };

  /* ---------- MOBILE SWIPE ---------- */
  const onTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const onTouchEnd = (e) => {
    if (!touchStartX.current) return;
    const diff = touchStartX.current - e.changedTouches[0].clientX;
    if (diff > 60) flipNext();
    if (diff < -60) flipPrev();
    touchStartX.current = null;
  };

  return (
    <div className="flex flex-col items-center py-10 bg-[#FFFAF9]">
      <h2 className="text-2xl font-bold text-[#381700] mb-6">
        Our Catalog
      </h2>

      {/* BOOK */}
      <div
        className="relative w-[320px] h-[450px] perspective-[1600px]"
        onTouchStart={onTouchStart}
        onTouchEnd={onTouchEnd}
      >
        {pages.map((img, index) => {
          const flipped = index < page;

          return (
            <div
              key={index}
              className="absolute inset-0 origin-left"
              style={{
                transform: flipped
                  ? "rotateY(-180deg)"
                  : "rotateY(0deg)",
                transition:
                  "transform 0.85s cubic-bezier(0.4, 0, 0.2, 1)",
                transformStyle: "preserve-3d",
                zIndex: pages.length - index,
              }}
            >
              {/* FRONT */}
              <img
                src={img}
                alt={`Page ${index + 1}`}
                className="absolute inset-0 w-full h-full object-cover rounded-r-xl shadow-xl"
                style={{ backfaceVisibility: "hidden" }}
              />

              {/* BACK (PREVIOUS PAGE) */}
              {index > 0 && (
                <img
                  src={pages[index - 1]}
                  alt=""
                  className="absolute inset-0 w-full h-full object-cover rounded-l-xl"
                  style={{
                    transform: "rotateY(180deg)",
                    backfaceVisibility: "hidden",
                  }}
                />
              )}
            </div>
          );
        })}
      </div>

      {/* CONTROLS */}
      <div className="flex gap-4 mt-6">
        <button
          onClick={flipPrev}
          disabled={page === 0}
          className="px-4 py-2 bg-[#381700] text-white rounded disabled:opacity-40"
        >
          Prev
        </button>

        <button
          onClick={flipNext}
          disabled={page === pages.length - 1}
          className="px-4 py-2 bg-[#381700] text-white rounded disabled:opacity-40"
        >
          Next
        </button>

      </div>

        <a
          href={sakhi_menu_pdf}
          download="Sakhi_Catalog.pdf"
          className="mt-4 inline-flex items-center gap-2 px-4 md:px-5 py-1.5 text-sm md:text-base md:py-2.5 bg-[#EDB5A4] text-[#381700] font-semibold rounded-lg shadow hover:opacity-90 transition"
        >
          Download PDF
        </a>
      <p className="md:hidden text-sm text-gray-500 mt-3">
        Swipe left or right to flip pages
      </p>
    </div>
  );
};

export default CatalogBook;
